import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './i18n';  // Cette ligne est importante pour charger la configuration d'i18n
import Layout from './Components/layout';
import Home from './Pages/Home';
import List from './Pages/List';
import Forecasts from './Pages/Forecasts';
import Details from './Pages/Details';
import './Css/global.css';
import RegisterForm from './Pages/RegisterForm'
import Login from './Pages/Login';
import AbonnementsPage from "./Pages/AbonnementsPage";
import { clearAllCache } from './Data/dataCache';
import { AuthProvider } from './Auth/autoContext';  // <-- Assure-toi que c'est bien le bon chemin
// import Payment from './Pages/Payment';
import UpgradePremium from './Pages/UpgradePremium';
import Rights from './Pages/Rights';
import { ToastContainer } from 'react-toastify';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import 'react-toastify/dist/ReactToastify.css';
import VerifyEmail from './Pages/VerifyEmail';
import ForgotPassword from './Pages/ForgotPassword';
import ResetPassword from './Pages/ResetPassword';
import Faq from './Pages/Faq';
import ContactForm from './Pages/ContactForm';
import Profile from './Pages/Profile';
import Favorites from './Pages/Favorites';
import { HelmetProvider } from 'react-helmet-async';



const SESSION_FLAG = 'session-active';

if (!sessionStorage.getItem(SESSION_FLAG)) {
  // Supposé être un nouveau lancement => on nettoie le cache
  clearAllCache(); // <- ta fonction de nettoyage
}

sessionStorage.setItem(SESSION_FLAG, 'true');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <HelmetProvider>
    <React.StrictMode>
      <PayPalScriptProvider
        options={{
          "clientId": process.env.REACT_APP_PAYPAL_CLIENT_ID!,
          currency: "USD",
          vault: true,
          intent: "subscription"
        }}
      >
        <AuthProvider> {/* ✅ Fournit le contexte à toute l'app */}
          <Router>

            {/* 🔔 Toasts globaux */}
            <ToastContainer
              position="top-right"
              autoClose={4000}
              hideProgressBar={false}
              closeOnClick
              pauseOnHover
            />

            <Routes>
              <Route path='/' element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="list" element={<List />} />
                <Route path="forecasts" element={<Forecasts />} />
                <Route path="favorites" element={<Favorites />} />
                <Route path="stock/:symbol" element={<Details />} />
                <Route path="registerForm" element={<RegisterForm />} />
                <Route path="login" element={<Login />} />
                <Route path="verify-email" element={<VerifyEmail />} />
                <Route path="profile" element={<Profile />} />
                <Route path="abonnements" element={<AbonnementsPage />} />
                <Route path="upgradePremium" element={<UpgradePremium />} />
                <Route path="rights" element={<Rights />} />
                <Route path="faq" element={<Faq />} />
                <Route path="contactForm" element={<ContactForm />} />
                <Route path="forgotPassword" element={<ForgotPassword />} />
                <Route path="resetPassword" element={<ResetPassword />} />
              </Route>
            </Routes>
          </Router>
        </AuthProvider>
      </PayPalScriptProvider>
    </React.StrictMode>
  </HelmetProvider>
);
